const $ = require('jquery');

const CartOffscreenConstants = {
    checkoutButtonHeight: 74,
    categoryHeaderHeight: 50,
    navHeights: 100,
    stickyCartOffset: 70,
};

class CartOffscreenController {
    constructor($scope, $window, $element, $timeout, shopPageStateService, sessionStorageWrapper, trolleyService, analyticsService, breakpointsService) {
        this.$window = $window;
        this.$element = $element;
        this.$timeout = $timeout;
        this.shopPageStateService = shopPageStateService;
        this.sessionStorageWrapper = sessionStorageWrapper;
        this.analyticsService = analyticsService;

        this.isInSmallFormat = breakpointsService.isInSmallFormat;

        $scope.$on('$stateChangeStart', () => this.toggleOpen(false));

        $scope.$watch(
            () => this.shopPageStateService.isCartOpen,
            () => this.toggleOpen(this.shopPageStateService.isCartOpen),
        );

        $scope.$watch(
            () => trolleyService.itemCount,
            (newItemCount, oldItemCount) => {
                if (oldItemCount === 0 && newItemCount > 0) {
                    this.toggleOpen(true);
                }
            },
        );
    }

    $onInit() {
        // height to stick to the top
        // this is the height of the corporate header + category header which is
        // 30px + 50px = 80px
        this.stickyHeight = 80;

        this.$timeout(() => {
            this.shopPageStateService.isCartOpen = this.sessionStorageWrapper.getAndRemove('isCartOpen') === 'true';
        });
    }

    $postLink() {
        this.$cart = this.$element.find('.cartOffscreen');
        this.$mask = this.$element.find('.cartOffscreen-contentMask');
        this.$nav = $(document.body).find('.categoryHeader');

        $(this.$window).on('beforeunload.cartpanel', () => this.sessionStorageWrapper.set('isCartOpen', this.shopPageStateService.isCartOpen));

        if (!this.isInSmallFormat) {
            this.onScroll = () => requestAnimationFrame(() => this.setCartHeight());
            document.addEventListener('scroll', this.onScroll, { passive: true });
            $(this.$window).on('resize', this.setCartHeight.bind(this));
        }

    }

    $onDestroy() {
        $(this.$window).off('beforeunload.cartpanel');

        if (!this.isInSmallFormat) {
            document.removeEventListener('scroll', this.onScroll, { passive: true });
            $(this.$window).off('resize', this.setCartHeight.bind(this));
        }
    }

    toggleClasses() {
        this.$cart.toggleClass('is-open', this.shopPageStateService.isCartOpen);
        this.$mask.toggleClass('is-masked', this.shopPageStateService.isCartOpen);
    }

    toggleOpen(open = !this.shopPageStateService.isCartOpen) {
        // This function sometimes gets called twice. Once by the ng-click from the template
        // and once by the watcher in the constructor. This is for performance reasons - if we always
        // wait for the watcher we have to wait 2 digest cycles which is slower on mobile devices.
        this.shopPageStateService.isCartOpen = open;

        this.shopPageStateService.toggleBodyScroll(!this.shopPageStateService.isCartOpen);
        this.toggleClasses();

        if (this.shopPageStateService.isCartOpen) {
            this.analyticsService.pushEvent(this.analyticsService.events.TOGGLE_PANEL);
        }

        this.setCartHeight();
    }

    setCartHeight() {
        // Position checkout button to bottom of cart slider on desktop. (ckdx-80)
        if (this.isInSmallFormat) {
            return;
        }

        const hasSticky = this.$cart.hasClass('is-sticky');
        let height = 0;
        if (hasSticky) {
            height = this.$window.innerHeight - CartOffscreenConstants.stickyCartOffset;
        } else {
            const navTop = this.$nav.offset().top;
            const padding = this.$nav.offset().top - CartOffscreenConstants.navHeights;
            height = this.$window.innerHeight + document.documentElement.scrollTop - navTop - CartOffscreenConstants.categoryHeaderHeight + padding;
        }

        if (this.shopPageStateService.isCartOpen) {
            height -= CartOffscreenConstants.checkoutButtonHeight;
        }

        this.$cart.height(height);
    }
}

const cartOffscreenComponentDefinition = {
    controller: ['$scope', '$window', '$element', '$timeout', 'ShopPageStateService', 'SessionStorageWrapper', 'TrolleyService', 'AnalyticsService', 'BreakpointsService', CartOffscreenController],
    template: require('./cart-offscreen.component.html').trim(),
};

module.exports = {
    CartOffscreenController,
    cartOffscreenComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/cart/cart-offscreen.component.js